{
	"ariaConfirmStyleNaming": "confirm_style_naming",
	"ariaNewStyleName": "New AI Style Name",
	"errorSaveStyle": "Failed to save style. Please try again."
}
